<script lang="ts" setup>
import BtnBecomeTutor from '@Widgets/Header/BtnBecomeTutor.vue'
import { AppLogo } from '@UI/Logos/AppLogo'

defineOptions({
  name: 'AppHeader',
})

</script>

<template>
  <div class="app-header">
    <div class="app-header__container">
      <a
        class="app-header__logo"
        href="https://brighterly.com"
        aria-label="Brighterly home"
      >
        <AppLogo />
      </a>
      <BtnBecomeTutor
        size="small"
        from="header"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/AppHeader.scss" />